import { useAuth } from "@clerk/clerk-react";
import { CLERK_AVAILABLE } from "./auth";

// Type definition for auth hook return value
export interface AuthHook {
  isSignedIn: boolean;
  getToken: () => Promise<string | null>;
}

/**
 * Auth hook that works with or without Clerk
 * - When Clerk is configured: uses real auth
 * - When Clerk is NOT configured: demo mode (always signed in)
 */
export function useAuthConditional(): AuthHook {
  // If Clerk is available, use the real auth hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const clerkAuth = CLERK_AVAILABLE ? useAuth() : null;

  if (CLERK_AVAILABLE && clerkAuth) {
    return {
      isSignedIn: clerkAuth.isSignedIn ?? false,
      getToken: async () => {
        if (!clerkAuth.getToken) return null;
        return clerkAuth.getToken();
      },
    };
  }

  // Demo mode: always signed in with no token
  return {
    isSignedIn: true,
    getToken: async () => null,
  };
}

// Export for reference
export { CLERK_AVAILABLE };
